import { stringify } from 'querystringify';
import fetch from 'node-fetch';
import createConfig from '../../config';

const getCategories = async ({
  categoryId = '',
  depth = 3,
  subset = 'mobileSite',
} = {}) => {
  const id = categoryId !== '' ? `/${categoryId}` : '';
  const { host } = window.location;
  const query = stringify({ depth, subset, host });
  const { urls } = createConfig();
  const uri = `${urls.base}/header/api/categories${id}?${query}`;
  const res = await fetch(uri, { credentials: 'include' });
  const json = await res.json();

  if (res.status !== 200) {
    return Promise.resolve({ error: json });
  }
  return Promise.resolve(json);
};

export default getCategories;
